<template>
  <section style="margin-top: 0px; margin-bottom: 0px;">
    <nav class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3 p-y-2" v-if="breadCrumb.length">
      <ul class="crumbs mvt-breadcrumb">
        <li v-for="crumb in breadCrumb" :key="crumb?.url">
          <span v-if="!crumb.url">{{crumb.text}}</span>
          <a v-else :href="crumb.url" :class="{'link': !isBanner}" v-ga:click>{{crumb.text}}</a>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script src="./sitemap-breadcrumb.js"></script>